/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import { connect } from 'react-redux';

export default connect(
  (state, ownProps) => {
    const locale = state.localePicker;
    const localesRequest = ownProps.requests.locales;

    const currentLocale = localesRequest.isCompleted
                          ? localesRequest.value.find((l) => l.code === locale)
                          : undefined;

    return { localeName: currentLocale ? currentLocale.name : '' };
  }
);
